import { Channel } from './channel.model';
import { Customer, Identity } from './customer.model';

export interface VerifyRegistration extends Channel { }
export interface VerifyPreRegistration extends Identity, Channel { }
export interface VerifyLineID extends Customer, Identity, Channel { }
export interface VerifyCustomer extends Customer { }


export enum ResponseCodeVerifyCustomer {
    SUCCESS = 'CM0001',
    NOTFOUND_IDCARD = 'F00000',
    NOTFOUND_PHONE = 'CM0002'
}


export enum ResponseStateRegistration {
    REGISTERED_ALREADY = 'S20000',
    NOT_REGISTERED = 'N20001',
    PRE_REGISTERED = 'L20002',
    PRE_REGISTERED_PHONE_NOT_MATCH = 'L20001',
    OTHER_ERROR = 'E40000'
}

export enum ResponseStateLineID {
    EX_LINE_ID = "S20000",
    NEW_LINE_ID = "N20001"
}

export enum ResponseStateVerifyIdentity {
    MATCH = "S20000",
    UNMATCH = "N20001",
    OTHER_ERROR = "E40000"
}

export interface CheckRegisterAndValidateDataReference{
    // channel_identity: string,
    electronic_channel: number,
    application_channel_reference: string,
    identity_id?: string,
    register_type: number,
    ref_code: string,
    subchannel?: number
}
export interface CheckRegisterAndValidateDataReferenceRespond{
    state_code:string,
    description:string
}

export enum ResponseCheckRegisterAndValidate{
    SUCCESS = "S200",
    UNMATCH_IN_CASE_LINE_REGISTER = "E401",
    OTHER_DEVICE = "E402",
    UNMATCH_IN_CASE_LINE_PRE_REGISTER = "E403",
    UNMATCH_IN_CASE_SMS = "E501",
    LEAD_EXPIRED = "E502"
}